module.exports = __webpack_public_path__ + "static/the-complete-persepolis-e55a74022a4574ef9ea2471e65515ff2.jpg";